import { Warning, WarningsToDisplayProvider } from '@app/interfaces/warnings-to-display-provider.interface';
import { BankAccount } from '@app/models/common/bank-account.model';
import { Office } from '@app/models/company/office.model';
import { Employee } from '@app/models/employee/employee.model';
import { keyBy, values } from 'lodash-es';

export class JobAndPayWarningProvider implements WarningsToDisplayProvider {
    private offices: { [key: number]: Office } = {};
    private warnings = {
        missingBranch: {
            message: 'employees.jobAndPay.warnings.missingBranch',
            active: false,
        },
        missingInstitution: {
            message: 'employees.jobAndPay.warnings.missingInstitution',
            active: false,
        },
        missingAccountNumber: {
            message: 'employees.jobAndPay.warnings.missingAccountNumber',
            active: false,
        },
        officeMissing: {
            message: 'employees.jobAndPay.warnings.officeMissing',
            active: false,
        },
        officeInvalid: {
            message: 'employees.jobAndPay.warnings.officeInvalid',
            active: false,
            params: {},
        },
    };

    constructor(
        private employee: Employee,
        private bankAccount: BankAccount,
        offices: Office[],
        private isQcSupported: boolean
    ) {
        this.offices = keyBy(offices, 'id');
        this.determineActiveWarnings();
    }

    warningsToDisplay(): Warning[] {
        return values(this.warnings).filter((warning) => warning.active);
    }

    private determineActiveWarnings(): void {
        this.markBankInstitutionMissing();
        this.markBankBranchMissing();
        this.markBankAccountNumberMissing();
        this.markOfficeMissing();
        this.markOfficeInvalid();
    }

    private markBankInstitutionMissing(): void {
        if (this.bankAccount.institutionNumber?.length > 0) {
            return;
        }

        this.warnings.missingInstitution.active = true;
    }

    private markBankBranchMissing(): void {
        if (this.bankAccount.branchNumber?.length > 0) {
            return;
        }

        this.warnings.missingBranch.active = true;
    }

    private markBankAccountNumberMissing(): void {
        if (this.bankAccount.accountNumber?.length > 0) {
            return;
        }

        this.warnings.missingAccountNumber.active = true;
    }

    private markOfficeMissing(): void {
        if (this.employee.officeId != null) {
            return;
        }

        this.warnings.officeMissing.active = true;
    }

    private markOfficeInvalid(): void {
        if (!this.employee.officeId) return;
        const office = this.offices[this.employee.officeId];
        if (office?.province != 'QC' || this.isQcSupported) {
            return;
        }

        this.warnings.officeInvalid.active = true;
        this.warnings.officeInvalid.params = { name: office.name, province: office.province };
    }
}
